import { render, staticRenderFns } from "./PriorityHistory.vue?vue&type=template&id=1d40639c&scoped=true"
import script from "./PriorityHistory.vue?vue&type=script&lang=js"
export * from "./PriorityHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40639c",
  null
  
)

export default component.exports